export const apiRoot = '/api/iam/authn/v1';

export const oidc = {
    discoveryUrl: '/iam/authn/.well-known/openid-configuration',
    stsAuthority: '/api/iam/authn',
    clientId: 'iam-ui',
    clientRoot: '/',
    clientScope: 'openid profile email groups',
    end_session_endpoint: '/oidc/logout',
};
